export class AUTHGWCONSTANTS {
  public static bearerToken: string = '&%T&%(#@IKTU76&%$$<YHG<U&$' + window.location.hostname;
  public static xOriginKey: string = '&%W4OKUY<GK^%$I&^KHTFJGVH&' + window.location.hostname;
  public static xApiKey: string = '&%X8UK$%#$#YGLUH^$%&^JH&Y0' + window.location.hostname;
  public static loggedIn: string = '&HG*&K$%#$JHGFY$#@H^$%H&D$%' + window.location.hostname;
  public static profile = 'KJHFGJHGFJHGFGH';
  public static phoneNumber = '';
  public static email = '';
}
